import React, { FunctionComponent } from 'react';

import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { I18nProviderWrapper } from '@components/common/I18nProviderWrapper';

import { Brandfolder, Organization } from './customPeopleTagTypes';

import { PageNotFound } from './PageNotFound';
import { Home } from './people_page/Home';
import { PersonDetailsPage } from './person_details_page/PersonDetailsPage';

interface PeopleTagsProps {
  brandfolder: Brandfolder;
  organization: Organization;
  orgApiKey: string;
}

export const PeopleTags: FunctionComponent<PeopleTagsProps> = ({ brandfolder, organization, orgApiKey }) => {
  const path = `/${brandfolder.slug}/people_tags`;
  return (
    <I18nProviderWrapper>
      <BrowserRouter basename="/">
        <Routes>
          <Route path={path}>
            <Route
              element={
                <Home
                  brandfolder={brandfolder}
                  orgApiKey={orgApiKey}
                  organization={organization}
                />
              }
              index
            />
            <Route element={<PersonDetailsPage />} path={`${path}/:id`} />
            <Route element={<PageNotFound organization={organization} />} path="*" />
          </Route>
        </Routes>
      </BrowserRouter>
    </I18nProviderWrapper>
  );
};
